(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      // Initialize scroll state classes
      const initialScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.updateScrollStateClasses(initialScrollTop);

      // Initialize body classes on page load
      this.initializeBodyClasses();

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    initializeBodyClasses() {
      // Add initial utility classes to body based on current scroll position
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const body = document.body;

      // Add scroll position classes
      if (scrollTop <= 10) {
        body.classList.add('header-at-top');
        body.classList.remove('header-scrolled');
      } else {
        body.classList.remove('header-at-top');
        body.classList.add('header-scrolled');
      }

      // Add viewport height classes
      if (scrollTop < windowHeight) {
        body.classList.add('scroll-under-viewport');
        body.classList.remove('scroll-over-viewport');
      } else {
        body.classList.remove('scroll-under-viewport');
        body.classList.add('scroll-over-viewport');
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    updateScrollStateClasses(scrollTop) {
      // Threshold for considering the page "scrolled" (you can adjust this value)
      const scrollThreshold = 10;
      const windowHeight = window.innerHeight;
      const body = document.body;

      if (scrollTop <= scrollThreshold) {
        // At the top of the page
        this.header.classList.add('header-at-top');
        this.header.classList.remove('header-scrolled');

        // Add body utility classes
        body.classList.add('header-at-top');
        body.classList.remove('header-scrolled');
      } else {
        // Page has been scrolled
        this.header.classList.remove('header-at-top');
        this.header.classList.add('header-scrolled');

        // Add body utility classes
        body.classList.remove('header-at-top');
        body.classList.add('header-scrolled');
      }

      // Add window height based utility classes
      if (scrollTop < windowHeight) {
        body.classList.add('scroll-under-viewport');
        body.classList.remove('scroll-over-viewport');
      } else {
        body.classList.remove('scroll-under-viewport');
        body.classList.add('scroll-over-viewport');
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Add state classes for styling based on scroll position
      this.updateScrollStateClasses(scrollTop);

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Standalone scroll state watcher for when sticky header is disabled
  class HeaderScrollWatcher {
    constructor() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;

      this.init();
    }

    init() {
      // Initialize scroll state classes
      const initialScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.updateScrollStateClasses(initialScrollTop);

      // Initialize body classes on page load
      this.initializeBodyClasses();

      // Bind scroll event
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    initializeBodyClasses() {
      // Add initial utility classes to body based on current scroll position
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const body = document.body;

      // Add scroll position classes
      if (scrollTop <= 10) {
        body.classList.add('header-at-top');
        body.classList.remove('header-scrolled');
      } else {
        body.classList.remove('header-at-top');
        body.classList.add('header-scrolled');
      }

      // Add viewport height classes
      if (scrollTop < windowHeight) {
        body.classList.add('scroll-under-viewport');
        body.classList.remove('scroll-over-viewport');
      } else {
        body.classList.remove('scroll-under-viewport');
        body.classList.add('scroll-over-viewport');
      }
    }

    updateScrollStateClasses(scrollTop) {
      const scrollThreshold = 10;
      const windowHeight = window.innerHeight;
      const body = document.body;

      if (scrollTop <= scrollThreshold) {
        this.header.classList.add('header-at-top');
        this.header.classList.remove('header-scrolled');

        // Add body utility classes
        body.classList.add('header-at-top');
        body.classList.remove('header-scrolled');
      } else {
        this.header.classList.remove('header-at-top');
        this.header.classList.add('header-scrolled');

        // Add body utility classes
        body.classList.remove('header-at-top');
        body.classList.add('header-scrolled');
      }

      // Add window height based utility classes
      if (scrollTop < windowHeight) {
        body.classList.add('scroll-under-viewport');
        body.classList.remove('scroll-over-viewport');
      } else {
        body.classList.remove('scroll-under-viewport');
        body.classList.add('scroll-over-viewport');
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.updateScrollStateClasses(scrollTop);
    }

    destroy() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }
  }

  // Initialize scroll watcher if no sticky-header element exists
  document.addEventListener('DOMContentLoaded', () => {
    const stickyHeaderElement = document.querySelector('sticky-header');
    if (!stickyHeaderElement) {
      window.headerScrollWatcher = new HeaderScrollWatcher();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
